import { NotificationCategoryDTO } from "./INotificationCategoryDTO";
import { NotificationSubCategoryDTO } from "./INotificationSubCategoryDTO";
import { ICustomerPublicDTO } from "./user-dto";

export enum CustomerNotificationStatusEnum {
  UNREAD = "u",
  READ = "r",
  FAKE_READ = "fr",
  HIDDEN = "h",
  EXCLUDED = "x",
}

export type CustomerNotificationStatusTypes =
  `${CustomerNotificationStatusEnum}`;

export interface CustomerNotificationDTO {
  id: number;
  customer: number;
  customerData: ICustomerPublicDTO;
  category: number;
  categoryData: NotificationCategoryDTO;
  subCategory: number;
  subCategoryData: NotificationSubCategoryDTO;
  title: string;
  metadata: object;
  status: CustomerNotificationStatusTypes;
  actionAt: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface ICustomerNotificationSelectOptionsDTO {
  status: CustomerNotificationStatusTypes;
  text: string;
  description?: string;
}
